"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearDiscountsLoyalty = exports.getSalesChannels = exports.deleteDiscount = exports.updateDiscountV2 = exports.updateDiscount = exports.addDiscountV2 = exports.addDiscount = exports.getDiscountById = exports.getDiscounts = exports.getDiscountByIdV2 = exports.getAllDiscountsV2 = exports.getDiscountsV2WithoutPagination = exports.getDiscountsV2 = void 0;
const shared_1 = require("@getgreenline/shared");
const getDiscountsV2 = (companyId, searchFilter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v2/companies/${companyId}/discounts`, {
        params: searchFilter,
    });
    return response.data;
});
exports.getDiscountsV2 = getDiscountsV2;
// To replace the GET V2 /discounts/all wrapper and endpoint
// Uses the same endpoint as above, but returns data without pagination
const getDiscountsV2WithoutPagination = (companyId, searchFilter) => __awaiter(void 0, void 0, void 0, function* () {
    const allDiscounts = [];
    let hasMoreDiscounts = true;
    const limit = 300;
    let offset = 0;
    while (hasMoreDiscounts) {
        const { data: { data: discounts }, } = yield shared_1.axios.get(`/api/v2/companies/${companyId}/discounts`, {
            params: Object.assign(Object.assign({}, searchFilter), { limit,
                offset }),
        });
        allDiscounts.push(...discounts);
        if (discounts.length < limit) {
            hasMoreDiscounts = false;
        }
        else {
            offset += limit;
        }
    }
    return allDiscounts;
});
exports.getDiscountsV2WithoutPagination = getDiscountsV2WithoutPagination;
/**
 * @deprecated
 */
const getAllDiscountsV2 = (companyId, searchFilter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v2/companies/${companyId}/discounts/all`, {
        params: searchFilter,
    });
    return response.data;
});
exports.getAllDiscountsV2 = getAllDiscountsV2;
const getDiscountByIdV2 = (companyId, discountId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v2/companies/${companyId}/discounts/${discountId}`);
    return response.data;
});
exports.getDiscountByIdV2 = getDiscountByIdV2;
/**
 * @deprecated since v2
 */
const getDiscounts = (companyId, searchFilter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/discount`, {
        params: searchFilter,
    });
    return response.data.discounts;
});
exports.getDiscounts = getDiscounts;
/**
 * @deprecated since v2
 */
const getDiscountById = (companyId, discountId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/discount/${discountId}`);
    return response.data;
});
exports.getDiscountById = getDiscountById;
/**
 * @deprecated since v2
 */
const addDiscount = (companyId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/company/${companyId}/discount`, createObject);
    return response.data;
});
exports.addDiscount = addDiscount;
const addDiscountV2 = (companyId, discount, skipAutoDiscountValidation) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v2/companies/${companyId}/discounts`, discount, {
        params: skipAutoDiscountValidation === undefined ? undefined : { skipAutoDiscountValidation },
    });
    return response.data;
});
exports.addDiscountV2 = addDiscountV2;
/**
 * @deprecated since v2
 */
const updateDiscount = (companyId, discountId, updateObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/discount/${discountId}`, updateObject);
    return response.data;
});
exports.updateDiscount = updateDiscount;
const updateDiscountV2 = (companyId, discount, skipAutoDiscountValidation) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v2/companies/${companyId}/discounts/${discount.id}`, discount, {
        params: skipAutoDiscountValidation === undefined ? undefined : { skipAutoDiscountValidation },
    });
    return response.data;
});
exports.updateDiscountV2 = updateDiscountV2;
const deleteDiscount = (companyId, discountId) => __awaiter(void 0, void 0, void 0, function* () {
    return yield shared_1.axios.delete(`/api/v1/company/${companyId}/discount/${discountId}`);
});
exports.deleteDiscount = deleteDiscount;
const getSalesChannels = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v2/companies/${companyId}/discounts/sales-channels`);
    return response.data;
});
exports.getSalesChannels = getSalesChannels;
const clearDiscountsLoyalty = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v2/companies/${companyId}/discounts/actions/clear-loyalty`);
    return response.data;
});
exports.clearDiscountsLoyalty = clearDiscountsLoyalty;
//# sourceMappingURL=discounts.js.map